export const SHIPMENT_TEMPLATE_CONTROL = {
  title: 'Yeni ürün eklerken teslimat şablonunuzu n11 özel kargo kampanyasına katılarak oluşturmanız gerekmektedir.',
  message: 'Teslimat Bilgileri alanından kampanyayı onaylayın, "Kampanyaya Katıl" butonuna tıklayarak şablonunuzu oluşturun, ürünlerinizi en uygun fiyatla gönderin.',
  negativeBtnText: 'Vazgeç',
  positiveBtnText: 'Teslimat Bilgileri',
  positiveBtnUrl: '/selleroffice/product/shippingInformationList',
}

export const DOCUMENT_CONTROL = {
  title: '',
  message: 'Evraklarınız tamamlanmadan ürün girişi yapamazsınız. Evrak Yönetimi butonuna tıklayarak evraklarınızı tamamlayabilirsiniz.',
  negativeBtnText: 'Vazgeç',
  positiveBtnText: 'Evrak Yönetimi',
  positiveBtnUrl: '/selleroffice/documentManagement',
}

export const SELLER_SHOP_CONTROL = {
  title: '',
  message: 'Ürün yükleyebilmek için mağazanızın aktif olması gerekmektedir. Süreçle ilgili bilgi almak için talep açabilirsiniz.',
  negativeBtnText: '',
  positiveBtnText: '',
}

export const GIB_CONTROL = {
  FORCE_APPROVE: "FORCE_APPROVE",
  APPROVE: "APPROVE"
}

export const REDIRECTION = "REDIRECTION";